import { ActionType } from '../../abacus/enums/action-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const peopleInvolvedDefinition: ResourceDefinition = {
  title: 'People Involved',
  nameSingular: 'People Involved',
  namePlural: 'People Involved',
  className: 'PeopleInvolved',
  mainIdentifier: 'name',
  slug: 'taxonomies/people-involveds',
  path: 'people-involveds',
  icon: 'icon-grid',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.CREATE],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Edit',
      permission: 'editTaxonomies',
      action: (peopleInvolved) => ({
        type: ActionType.Link,
        link: {
          path: `${peopleInvolvedDefinition.path}/${peopleInvolved.id}/edit`
        }
      })
    },
    {
      label: 'Delete',
      permission: 'deleteTaxonomies',
      action: (peopleInvolved) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: peopleInvolved,
          definition: peopleInvolvedDefinition
        }
      })
    }
  ]
}
